<div  fxLayout="column" class="page-container">
  <div class="top-image">
    <img ngSrc="assets/branding/top-traces2.png" alt="Top Traces" height="500" width="643" priority decoding="async">
  </div>
  <div fxLayout="column" class="content-container" fxLayoutAlign="center center">
    <div  fxLayoutAlign="center center">
      <h1 >Are you tech to the core? <br> Check out the results to find out.</h1>
    </div>
    <div class="button-container">
      <eon-ui-button fullWidth text="Show ranking" (click)="navigateToScore()" scheme=white></eon-ui-button>
    </div>
    <div class="bottom-image">
      <img ngSrc="assets/branding/bottom-traces3.png" alt="Bottom Traces" height="500" width="1401"  loading="eager" decoding="async">
    </div>
  </div>

